import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3C6E71",
      dark: "#284B63",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1E3A5F",
      dark: "#162E4A",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#353535",
      dark: "#2A2A2A",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#B23A48",
    },
    background: {
      default: "#ECEFF3",
      paper: "#FFFFFF",
    },
    divider: "rgba(0,0,0,0.08)",
  },
  typography: {
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "10px 18px",
          transition: "all 0.2s ease",
        },
        containedPrimary: {
          backgroundColor: "#3C6E71",
          "&:hover": {
            backgroundColor: "#284B63",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
          },
        },
        containedInfo: {
          backgroundColor: "#1E3A5F",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#162E4A",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
          },
        },
        containedSecondary: {
          backgroundColor: "#353535",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#2A2A2A",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
          },
        },
        outlined: {
          backgroundColor: "#E6EBF0",
          borderColor: "rgba(0,0,0,0.12)",
          borderWidth: "1px",
          color: "#1F2937",
          "&:hover": {
            backgroundColor: "#DCE3EA",
            borderColor: "#3C6E71",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 18px rgba(0,0,0,0.10)",
          },
          "&:active": {
            transform: "translateY(0px)",
            boxShadow: "0px 3px 10px rgba(0,0,0,0.10)",
          },
        },
        outlinedPrimary: {
          backgroundColor: "#E6EBF0",
          borderColor: "rgba(0,0,0,0.12)",
          borderWidth: "1px",
          color: "#1F2937",
          "&:hover": {
            backgroundColor: "#DCE3EA",
            borderColor: "#3C6E71",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 18px rgba(0,0,0,0.10)",
          },
          "&:active": {
            transform: "translateY(0px)",
            boxShadow: "0px 3px 10px rgba(0,0,0,0.10)",
          },
        },
        outlinedSecondary: {
          backgroundColor: "#E6EBF0",
          borderColor: "rgba(0,0,0,0.12)",
          color: "#1F2937",
          borderWidth: "1px",
          "&:hover": {
            backgroundColor: "#DCE3EA",
            borderColor: "#3C6E71",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 18px rgba(0,0,0,0.10)",
          },
          "&:active": {
            transform: "translateY(0px)",
            boxShadow: "0px 3px 10px rgba(0,0,0,0.10)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.06)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.06)",
        },
      },
    },
  },
});

export default theme;
